import { TextField, TextFieldProps } from '@mui/material';
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form';

type InviteInputProps = Readonly<{
  name: string;
  rules?: RegisterOptions;
}> &
  TextFieldProps;

export const InviteInput = ({ name, rules, ...otherProps }: InviteInputProps) => {
  const methods = useFormContext();

  return (
    <Controller
      {...methods}
      name={name}
      defaultValue=""
      rules={rules}
      render={({ field, fieldState: { error } }) => {
        return (
          <TextField
            {...field}
            {...otherProps}
            id={name}
            fullWidth
            error={!!error}
            helperText={error ? (error?.message as unknown as string) : ''}
          />
        );
      }}
    />
  );
};
